import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import React, { useContext, useEffect, useState } from "react";
import { APIContext } from "../../Contexts/APIContext";
import QaiChallengeNote from "../../QaiScorecardChallenge/Shared/QaiChallengeNote";
import GetChallengeNoteViewModel from "../../QaiScorecardChallenge/Shared/ViewModels/GetChallengeNoteViewModel";
import DialogTitle from "@mui/material/DialogTitle";

interface IAgentQaiChallengeFeedbackProps {
    open: boolean
    close: () => void
}

export default function AgentQaiChallengeFeedback({ open, close }: IAgentQaiChallengeFeedbackProps) {
    const { get } = useContext(APIContext);
    const [challenges, setChallenges] = useState<GetChallengeNoteViewModel[]>([]);

    useEffect(() => {
        get('QaiScorecardChallenge', `GetAgentsChallenges`, (data) => setChallenges(data))
    }, [])

    return (
        <Dialog open={open} maxWidth='md'>
            <DialogTitle>Q-AI Challenges</DialogTitle>
            <Grid container size={12} minHeight='800px'>
                <Grid container size={12} maxHeight='740px' sx={{ overflowY: 'auto' }}>
                    {
                        challenges.map(challenge =>
                            <QaiChallengeNote view={'Agent'} note={challenge} />)
                    }
                </Grid>
                <Grid container size={12} justifyContent='flex-end' alignItems='flex-end' paddingBottom={1}>
                    <Grid>
                        <Button variant='contained' onClick={close}>Close</Button>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
}